import { useIsMobile } from '@client/hooks/dom.hooks';

export const WidthLoader = ({ children }) => {
  const isMobile = useIsMobile();

  return children(isMobile);
};
